import { getRuntimeEnvironment } from "../local/runtimeEnvironment";

const readEnv = (key) => (process.env[key] || "").trim();

export const supabaseUrl = readEnv("REACT_APP_SUPABASE_URL");
export const supabaseAnonKey = readEnv("REACT_APP_SUPABASE_ANON_KEY");
export const isDeveloperBypassAllowed = () =>
  getRuntimeEnvironment() === "development";

export const developerBypassAuth =
  readEnv("REACT_APP_DEV_BYPASS_AUTH") === "true" &&
  isDeveloperBypassAllowed();

export const missingSupabaseConfig = [
  !supabaseUrl && "REACT_APP_SUPABASE_URL",
  !supabaseAnonKey && "REACT_APP_SUPABASE_ANON_KEY",
].filter(Boolean);

export const isSupabaseConfigured = missingSupabaseConfig.length === 0;
